import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const FAQ = () => {
  const faqs = [
    {
      question: 'How long does an MVP take?',
      answer: 'Our typical MVP development takes 3-4 weeks from ideation to launch. This includes requirement analysis, design, development, testing, and deployment. The timeline may vary based on complexity and scope.'
    },
    {
      question: 'What technologies do you use?',
      answer: 'We use modern, proven technologies including React, Next.js, Node.js, Python, FastAPI, and various cloud platforms. We select the best tech stack based on your specific needs and scalability requirements.'
    },
    {
      question: 'Do you offer post-launch support?',
      answer: 'Yes! All our packages include post-launch support. Growth MVP includes 1 month of support, and Full Launch includes ongoing maintenance. We ensure your product runs smoothly and help with updates and improvements.'
    },
    {
      question: 'Can you integrate AI into my product?',
      answer: 'Absolutely! We specialize in AI-powered solutions including GPT integration, machine learning models, computer vision, and intelligent automation. Our team has extensive experience with OpenAI, Anthropic, and other AI platforms.'
    },
    {
      question: 'What is included in the fixed pricing?',
      answer: 'Our fixed pricing includes everything: design, development, testing, deployment, and initial support. No hidden costs or surprise fees. You get a complete, production-ready product at the quoted price.'
    },
    {
      question: 'How do we communicate during the project?',
      answer: 'We maintain transparent communication through your preferred channels (Slack, email, video calls). You get regular updates, can track progress in real-time, and have direct access to our development team.'
    }
  ];

  return (
    <section id="faq" className="py-24 px-6 relative bg-gradient-to-b from-black to-gray-900">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-white/60 font-semibold text-sm uppercase tracking-wide">FAQ</span>
          <h2 className="text-4xl md:text-5xl font-extrabold mt-4 mb-4 text-white">
            We've Answered the Most
            <span className="block">Asked Questions</span>
          </h2>
          <p className="text-gray-400 text-lg">Find quick answers to common questions</p>
        </div>

        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white/5 border border-white/10 rounded-lg px-6 hover:border-white/30 transition-colors duration-300 backdrop-blur-sm"
            >
              <AccordionTrigger className="text-left text-lg font-semibold text-white hover:text-gray-200 transition-colors duration-200 py-5">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-400 leading-relaxed pb-5">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;